/**
 * Sync the currently selected package/color combo into product forms
 * so EasySell COD picks up the right variant.
 */
function syncSelectedVariantToProductForm() {
  const checkedInput = document.querySelector(
    '.variant-card-picker__input:checked[data-variant-id], .desktop-package-picker__input:checked[data-variant-id]'
  );
  const variantId = checkedInput?.dataset?.variantId;
  if (!variantId) return;

  document
    .querySelectorAll('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]')
    .forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      if (input.value === String(variantId)) return;
      input.value = String(variantId);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
}

function isCodModeEnabled() {
  return window.HydroxSeal?.codFormEnabled !== false;
}

/**
 * Opens the EasySell COD Form modal.
 *
 * @returns {boolean}
 */
function openEasySellCodModal() {
  if (!isCodModeEnabled()) return false;

  syncSelectedVariantToProductForm();

  if (typeof window.openTysloForm === 'function') {
    try {
      window.openTysloForm();
      return true;
    } catch (error) {
      console.warn('[easysell-cod-trigger] openTysloForm failed', error);
    }
  }

  const selectors = [
    '.es-popup-button-product',
    '.es-popup-button-cart',
    'button[class*="es-popup-button-product"]',
    'a[class*="es-popup-button-product"]',
    '#es-popup-button',
    '#es-sticky',
  ];

  for (const selector of selectors) {
    const triggers = document.querySelectorAll(selector);
    for (const trigger of triggers) {
      if (!(trigger instanceof HTMLElement)) continue;
      if (trigger.classList.contains('es-popup-button-overwrite')) continue;
      if (trigger.hasAttribute('data-easysell-theme-trigger')) continue;
      trigger.click();
      return true;
    }
  }

  const modal = document.getElementById('easysell-modal');
  if (modal instanceof HTMLElement) {
    modal.style.display = 'block';
    document.querySelectorAll('html, body').forEach((node) => {
      if (node instanceof HTMLElement) node.style.overflow = 'hidden';
    });
    return true;
  }

  return false;
}

/**
 * @returns {boolean}
 */
function isEasySellPresent() {
  return Boolean(
    typeof window.openTysloForm === 'function' ||
      document.getElementById('easysell-modal') ||
      document.getElementById('easysell') ||
      document.querySelector(
        'easysell-form, .es-popup-button-product, .es-popup-button-cart, [class*="es-popup-button"]'
      )
  );
}

/**
 * @returns {boolean}
 */
function shouldOpenEasySellOnMobileVariantSelect() {
  return window.HydroxSeal?.easysellOpenOnMobileVariantSelect !== false;
}

/**
 * @param {EventTarget | null} target
 * @returns {HTMLElement | null}
 */
function getEasySellInterceptTarget(target) {
  if (!(target instanceof Element)) return null;

  return (
    /** @type {HTMLElement | null} */ (
      target.closest('[data-buy-now-button]') ||
        target.closest('[data-action="buy-now"]') ||
        target.closest('[data-easysell-open]') ||
        target.closest('.cart__checkout-button') ||
        target.closest('#checkout') ||
        target.closest('[name="checkout"]')
    )
  );
}

/**
 * @param {EventTarget | null} target
 * @returns {HTMLInputElement | null}
 */
function getAlreadySelectedMobilePackageInput(target) {
  if (!(target instanceof Element)) return null;
  if (!window.matchMedia('(max-width: 749px)').matches) return null;

  const card = target.closest('.variant-card-picker__card');
  const input = card?.querySelector('.variant-card-picker__input');
  if (!(input instanceof HTMLInputElement)) return null;
  if (!input.checked) return null;
  if (input.disabled || input.getAttribute('aria-disabled') === 'true') return null;

  return input;
}

window.openEasySellCodModal = openEasySellCodModal;
window.isEasySellPresent = isEasySellPresent;

document.addEventListener(
  'click',
  (event) => {
    if (!isCodModeEnabled()) return;

    const interceptTarget = getEasySellInterceptTarget(event.target);
    if (!interceptTarget) return;
    if (interceptTarget instanceof HTMLButtonElement && interceptTarget.disabled) return;

    if (!openEasySellCodModal()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    if (!isCodModeEnabled()) return;
    if (!shouldOpenEasySellOnMobileVariantSelect()) return;

    const selectedInput = getAlreadySelectedMobilePackageInput(event.target);
    if (!selectedInput) return;

    requestAnimationFrame(() => {
      openEasySellCodModal();
    });
  },
  true
);

document.addEventListener('change', (event) => {
  if (!isCodModeEnabled()) return;
  if (!shouldOpenEasySellOnMobileVariantSelect()) return;

  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;
  if (!target.classList.contains('variant-card-picker__input')) return;
  if (target.disabled || target.getAttribute('aria-disabled') === 'true') return;
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  requestAnimationFrame(() => {
    openEasySellCodModal();
  });
});
